import React, { PropsWithChildren } from "react";
import { Box, type BoxProps } from "@mui/material";
import { motion, AnimatePresence, type HTMLMotionProps } from "framer-motion";
import { colors } from "../../styles/theme";
import { getFluidsByKeysFunc } from "../../utils/fuilds";
import { StyledBorderFrame } from "../App/App.styled";

const MotionBox = motion.create(Box) as React.ComponentType<BoxProps & HTMLMotionProps<"div">> | any;

export type LoaderProps = PropsWithChildren<
  {
    open: boolean;
  } & BoxProps
>;

export const Overlay: React.FC<LoaderProps> = (props) => {
  const {
    open,
    children,
    sx,
    ...rest
  } = props;

  return (
    <AnimatePresence>
      {open && (
        <MotionBox
          key="fixed-fade-block"
          initial={false}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.6, ease: "easeOut" }}
          sx={{
            position: "absolute",
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            minWidth: '100%',
            minHeight: '100%',
            width: '100%',
            height: '100%',
            background: colors.background.v1,
            zIndex: (theme: any) => theme.zIndex.tooltip + 1,
          }}
          {...rest}
        >

          <StyledBorderFrame sx={getFluidsByKeysFunc({
            position: 'absolute',
            top: '64px',
            bottom: '64px',
            left: '64px',
            right: '64px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: 'calc(100% - 132px)',
            height: 'calc(100% - 132px)',
          }, ['top', 'bottom', 'left', 'right', 'width', 'height'])}>

            {children}
          </StyledBorderFrame>
        </MotionBox>
      )}
    </AnimatePresence>
  );
};
